module.exports = __webpack_public_path__ + "img/Mstar-logo-50px.e8433154.svg";